import axios from "axios";

const api = {
    fetch: () => axios.get(`/api/kpi/fetch-kpi-table`, { withCredentials: true }),
    fetchDataForAction: (key, id) => axios.get(`/api/kpi/fetch-data-for-action/${key}/${id}`, { withCredentials: true }),
    delete: (key, id) => axios.delete(`/api/kpi/delete-kpi-item/${key}/${id}`, { withCredentials: true }),
    update: (key, payload) => axios.post(`/api/kpi/update-kpi-items/${key}`, payload, { withCredentials: true }),
    create: (key, payload) => axios.post(`/api/kpi/create-kpi-items/${key}`, payload, { withCredentials: true }),
    initialize: (file) => axios.post(`/api/kpi/initialize`, createFormData(file), { withCredentials: true }),
    bulkUpdate: (file) => axios.post(`/api/kpi/bulk-update-kpis`, createFormData(file), { withCredentials: true }),
    export: () => axios.get(`/api/kpi/export-table`, { withCredentials: true, responseType: 'blob' })
        .then(res => handleExport(res.data))
        .catch(() => alert('Failed to export excel.')),
};

function createFormData(file) {
    const formData = new FormData();
    formData.append('sheet', file);
    return formData;
}

function handleExport(buffer) {
    const url = URL.createObjectURL(new Blob([buffer]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
        'download',
        'Metrics 2026.xlsx'
    );
    document.body.appendChild(link);
    link.click();
    
    URL.revokeObjectURL(url);
    link.remove();
}

export default api;